<template>
  <default-renderer
    v-bind:params="params"
    location />
</template>
<script>
  import defaultRenderer from '@/components/utils/ag-grid/default-renderer';

  export default { components: { defaultRenderer } };
</script>
